import React, { useEffect, useState } from "react";

import Card from "components/giftcard/Card";
import DownloadBox from "components/giftcard/DownloadBox";
import CodeInput from "components/giftcard/CodeInput";
import { giftcard_images } from "assets/img/giftcard/common";
import GiftcardButton from "components/giftcard/GiftcardButton";
import confetti from "components/common/confetti";
import {
    GlobalStyle,
    Page,
    Title,
    Subtitle,
    Header,
    Footer,
    Video,
    SectionComoReclamar,
} from "./Giftcard.styled";
import useQuery from "lib/useQuery";
import styled from "styled-components";

const StyledSection = styled.section`

`;

const Confetti = styled.canvas`
    background: transparent;
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 2;
`;


const Giftcard = () => {
    const [showheader, setShowHeader] = useState(true);
    const query = useQuery();
    let code = query.get("giftcardValue");
    const res = /^[a-zA-Z0-9]*$/

    if (!res.test(code)) code = null;

    const onConfettiEndCallback = () => {
        const video = document.querySelector('#video-tutorial');
        if (video) video.scrollIntoView({
            behavior: 'smooth'
        });
        setShowHeader(false);
    };
    const onClickVideo = () => {
        const video = document.getElementById('tutorial');
        video.play();
    };
    const confettiDelay = 100;
    const confettiEndOnFrame = 540;

    useEffect(() => {
        confetti(confettiDelay, onConfettiEndCallback, confettiEndOnFrame);
    }, []);

    return (
        <Page>
            <Confetti />
            <GlobalStyle />
            <StyledSection>
                <Title>Buengift</Title>
                <Subtitle>
                    {code
                        ? "¡Recibiste un regalo en criptomonedas!"
                        : "Tu próximo regalo en criptomonedas"}
                </Subtitle>
                {code && <CodeInput code={code} />}
                <Card />
                <GiftcardButton text="Descargar App" />
            </StyledSection>

            {code && (<>
                <SectionComoReclamar>
                    <Subtitle id="video-tutorial">
                        Sigue las siguientes instrucciones para reclamar tu
                        Giftcard
                    </Subtitle>
                    <Video id="tutorial" autoPlay muted onClick={onClickVideo}>
                        <source
                            src={giftcard_images.giftcardVideo}
                            type="video/mp4"
                        />
                    </Video>
                </SectionComoReclamar>
            </>)}

            <section className="show-desktop">
                <DownloadBox />
            </section>
            <GiftcardButton text="Descargar App" />

            <Footer>
                <p>Buenbit © 2023 | El mejor lugar para tus criptos</p>
            </Footer>
        </Page>
    );
};

export default Giftcard;
